import { FC } from 'react'
import { Slider } from '@/components/ui/slider.tsx'
import { Label } from '@/components/ui/label.tsx'

type ZoomProps = {
    zoom: number
    max: number
    onChange: (value: number) => void
}

export const Zoom: FC<ZoomProps> = ({ zoom, max, onChange }) => {
    return (
        <div className={'flex flex-col gap-1 justify-between'}>
            <Label>Zoom</Label>
            <div className={'flex items-center space-x-5 text-slate-400 text-sm'}>
                <span>{zoom}</span>
                <Slider
                    name="zoom_level"
                    id="zoom_level"
                    className={'w-full'}
                    min={1}
                    defaultValue={[zoom]}
                    max={max === Infinity ? 10 : max}
                    onValueChange={(value) => {
                        onChange(value[0])
                    }}
                />
            </div>
        </div>
    )
}
